import { z } from "zod";
import { defineEndpoint } from "./endpoint.js";
import { storefrontHostSchema } from "./storefront.js";
/**
 * SEO (B-81, SF-13): the indexable addresses of one shop for its `sitemap.xml` — published products, categories with
 * published products, and published pages — paged by cursor. Only the host's own tenant; nothing unpublished.
 */
export const sitemapEntrySchema = z.object({
    /** A path on the shop's main address (`/products/honey-500g`). */
    path: z.string(),
    lastmod: z.iso.datetime().nullable(),
});
export const shopSitemapSchema = z.object({
    data: z.array(sitemapEntrySchema),
    nextCursor: z.string().nullable(),
});
export const getShopSitemap = defineEndpoint({
    tag: "storefront",
    name: "getShopSitemap",
    method: "GET",
    path: "/v1/storefront/sitemap",
    access: { public: true },
    summary: "One page of the shop's indexable addresses (the first page adds home, categories and pages)",
    query: z.object({ host: storefrontHostSchema, cursor: z.string().max(300).optional() }),
    status: 200,
    response: shopSitemapSchema,
});
//# sourceMappingURL=storefront-seo.js.map